var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#142937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 26H41.3333V22.6667H22.6667V41.3333H41.3333V38H44V44H20V20H44V26ZM30.6667 38.6667V25.3333H45.3333V38.6667H30.6667ZM37.3333 34C37.8889 34 38.3613 33.8058 38.7507 33.4173C39.14 33.0289 39.3342 32.5564 39.3333 32C39.3324 31.4436 39.1382 30.9716 38.7507 30.584C38.3631 30.1964 37.8907 30.0018 37.3333 30C36.776 29.9982 36.304 30.1929 35.9173 30.584C35.5307 30.9751 35.336 31.4471 35.3333 32C35.3307 32.5529 35.5253 33.0253 35.9173 33.4173C36.3093 33.8093 36.7813 34.0036 37.3333 34ZM42.6667 36V28H33.3333V36H42.6667Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWallet);
export default __webpack_public_path__ + "static/media/whiteWallet.cf3632f0169b44c53dcf2e7b426e80b4.svg";
export { ForwardRef as ReactComponent };